import { customElement } from 'lit/decorators/custom-element.js';
import { container } from 'tsyringe';
import { AbstractStandardTimelineView } from '../abstract-standard-timeline.view';
import type { TimelineViewConfig } from '../_shared/timeline-view.config';
import { EmployeeRepository } from '../../domain/repositories/employee.repository';
import type { Issue } from '../../domain/entities/issue.entity';

const VIEW_CONFIG: TimelineViewConfig = {
    entityType: 'Employee',
    sort: { strategy: 'property', path: 'lastName', direction: 'ASC' },
    yItemPath: 'creator.uid',
    includes: ['creator', 'employees', 'project', 'keywords', 'employeeToIssueAssignments']
};

/**
 * Timeline view grouping issues by creator (employee who created the issue).
 * Route: /by-creator
 *
 * Y-axis: Employee — overrides populateTemplateFromYAxis to set creator field
 * instead of the default employees array.
 */
@customElement('o2d-creators-view')
export class CreatorsView extends AbstractStandardTimelineView {
    protected readonly viewStateName = 'creators';
    protected readonly viewConfig = VIEW_CONFIG;

    /** Assigns clicked employee as creator of template issue. */
    protected override async populateTemplateFromYAxis(template: Issue, yAxisUid: string): Promise<void> {
        const employeeRepo = container.resolve(EmployeeRepository);
        const employee = await employeeRepo.findOneById(yAxisUid);
        if (employee) {
            template.creator = employee;
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'o2d-creators-view': CreatorsView;
    }
}
